import { FileText } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const resources = [
  { name: "Latest Layout", file: "Latest Layout.pdf" },
  { name: "Preliminary Plan", file: "Preliminary Plan_28-02-2025_250301_193054 (1).pdf" },
  { name: "Type 1", file: "type 1.pdf" },
  { name: "Type 2", file: "type 2.pdf" },
  { name: "Type 3", file: "type 3.pdf" },
  { name: "Type 4", file: "type 4.pdf" },
];

export default function Resources() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-28 container py-12">
        <h1 className="text-5xl font-bold mb-12 text-center text-white">Resources</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {resources.map((doc, idx) => (
            <div
              key={doc.file}
              className="relative flex flex-col items-center bg-white dark:bg-gray-900 rounded-xl shadow-lg overflow-hidden p-6 group border border-gray-200 dark:border-gray-800 hover:shadow-xl transition-shadow animate-fade-in"
              style={{ animationDelay: `${idx * 50}ms` }}
            >
              <div className="flex items-center justify-center w-20 h-20 rounded-full bg-seafarer-orange/10 mb-4">
                <FileText className="w-10 h-10 text-seafarer-orange" />
              </div>
              <h2 className="text-lg font-semibold text-center mb-2 line-clamp-2">{doc.name}</h2>
              <p className="text-muted-foreground text-xs text-center mb-4 line-clamp-2">{doc.file}</p>
              <a
                href={`/resources/${doc.file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-auto px-4 py-2 rounded-md font-medium bg-seafarer-orange text-white hover:bg-seafarer-orange/90 transition-colors shadow"
                download
              >
                Download / View
              </a>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
} 